module.exports = __webpack_public_path__ + "static/media/pic2.257a7214.jpg";